'use client';
import { createContext, FC, useContext } from 'react';
import { TypeErrorDirective } from '@/core/generated-types';

interface ErrorDirectiveContextValue {
  errorDirectives: TypeErrorDirective[];
}

interface ErrorDirectiveProps {
  children: any;
  errorDirectives: TypeErrorDirective[];
}

const ErrorDirectiveContext = createContext({} as ErrorDirectiveContextValue);

export const useErrorDirectives = () => useContext(ErrorDirectiveContext);

export const ErrorDirectiveProvider: FC<ErrorDirectiveProps> = ({
  errorDirectives,
  children,
}) => {
  const errorContextValue = {
    errorDirectives,
  };

  return (
    <ErrorDirectiveContext.Provider value={errorContextValue}>
      {children}
    </ErrorDirectiveContext.Provider>
  );
};
